/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaDistributionBucket model module.
 * @module model/AqaDistributionBucket
 * @version v0
 */
export default class AqaDistributionBucket {
  /**
   * Constructs a new <code>AqaDistributionBucket</code>.
   * @alias module:model/AqaDistributionBucket
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaDistributionBucket</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaDistributionBucket} obj Optional instance to populate.
   * @return {module:model/AqaDistributionBucket} The populated <code>AqaDistributionBucket</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaDistributionBucket();
      if (data.hasOwnProperty('count'))
        obj.count = ApiClient.convertToType(data['count'], 'Number');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('rangeBottom'))
        obj.rangeBottom = ApiClient.convertToType(data['rangeBottom'], 'String');
      if (data.hasOwnProperty('rangeTop'))
        obj.rangeTop = ApiClient.convertToType(data['rangeTop'], 'String');
      if (data.hasOwnProperty('rawRangeBottom'))
        obj.rawRangeBottom = ApiClient.convertToType(data['rawRangeBottom'], 'String');
      if (data.hasOwnProperty('rawRangeTop'))
        obj.rawRangeTop = ApiClient.convertToType(data['rawRangeTop'], 'String');
      if (data.hasOwnProperty('onValue'))
        obj.onValue = ApiClient.convertToType(data['onValue'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} count
 */
AqaDistributionBucket.prototype.count = undefined;

/**
 * @member {String} value
 */
AqaDistributionBucket.prototype.value = undefined;

/**
 * @member {String} rangeBottom
 */
AqaDistributionBucket.prototype.rangeBottom = undefined;

/**
 * @member {String} rangeTop
 */
AqaDistributionBucket.prototype.rangeTop = undefined;

/**
 * @member {String} rawRangeBottom
 */
AqaDistributionBucket.prototype.rawRangeBottom = undefined;

/**
 * @member {String} rawRangeTop
 */
AqaDistributionBucket.prototype.rawRangeTop = undefined;

/**
 * @member {Boolean} onValue
 */
AqaDistributionBucket.prototype.onValue = undefined;

